module.exports = __webpack_public_path__ + "media/חברים.cc72da57.mp3";